import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-28068759")
const _hoisted_1 = { class: "text-link" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "primary" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textArrs, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.title) + " : ", 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.desp), 1)
      ]))
    }), 128))
  ]))
}